// Shared helpers for CSV/Excel export buttons and dynamic year dropdowns.
const API_BASE = process.env.REACT_APP_API_URL || '';

// Open a backend export endpoint as a file download (token passed via query string,
// which the PHP auth layer accepts as a fallback to the Authorization header).
export function downloadCsv(endpoint, params = {}) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== '' && v !== null && v !== undefined) p.set(k, v);
  });
  p.set('token', localStorage.getItem('token') || '');
  window.open(`${API_BASE}/api${endpoint}?${p.toString()}`, '_blank');
}

// Year list: 3 years back to next year, recomputed at import time so it never goes stale.
export const yearOptions = (() => {
  const y = new Date().getFullYear();
  const arr = [];
  for (let i = y - 3; i <= y + 1; i++) arr.push(i);
  return arr;
})();
